import React from 'react'
import { GetInTouchDiv } from './style'
import {AiOutlineTwitter, AiOutlineInstagram, AiOutlineFacebook, AiOutlineWhatsApp } from'react-icons/ai'

function GetInTouch() {
    return (
        <GetInTouchDiv>
            <div className="row roww pt-5">
                <div className=" col-md-4 col-sm-12 m-5 pt-5 firstdiv">
                    <h2>Get in touch.</h2>
                    <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit.</p>
                    <div className="icons">
                        <AiOutlineTwitter />
                        <AiOutlineInstagram />
                        <AiOutlineFacebook />
                        <AiOutlineWhatsApp />
                    </div>

                </div>
                <div className=" col-md-3 col-sm-12 pt-5 seconddiv">
                <input type="text" className="form-control" placeholder="Enter FullName" />
                <input type="text" className="form-control" placeholder="Enter Email Adress" />
                <input type="text" className="form-control lastinput" placeholder="Write your message..." />
                <button className="btn btn-default but" type="submit">Send Message</button>

                </div>          

            </div>
        </GetInTouchDiv>
    )
}

export default GetInTouch
